export const categoryMethods = {
    flatCategories(arr) {
        return Array.isArray(arr)
            ? arr.reduce((a, item) => {
                a.push(item);
                if (item.children) {
                    a = a.concat(flatCategories(item.children));
                }
                return a;
            }, []) : [];
    },
    imageHandler(category, alternativeImage) {
        if (category.image === null) {
            return alternativeImage;
        }
        return category.image
    },
    setLinkType(category, linkType) {

        if (linkType === 'blog') {
            return {name: 'Posts', query: {category: category.slug}}
        }

        if (linkType == 'Products') {
            return {name: 'Products', query: {category: [category.slug], category_column: 'slug'}}
        }

        return {name: 'SingleCategory', params: {slug: category.slug}}
    },
    clearRouter(linkType) {
        if (linkType == 'blog') {
            return {name: 'Posts'}
        } else {
            return {name: 'SingleCategory'}
        }
    },
    categoryShape(categories) {
        if (this.flatCategoriesShape) {
            return this.flatCategories(categories)
        }
        return categories
    },
}
